// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2uCwk","image":"Header_image__1HFUv","name":"Header_name__2YCel","info":"Header_info__Ib9w2","infoRow":"Header_infoRow__3Nlng"};